import type { UsageTotals } from '@autopilot/contracts';

const nf = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });

export function formatInt(n: number): string {
  return nf.format(Math.round(n));
}

/** Gesamttokens; unvollständige Usage nie als exakte Zahl (05 „Tokenrechnung“). */
export function formatUsage(usage: UsageTotals | null | undefined): string {
  if (!usage) return '–';
  if (!usage.complete) return `mindestens ${formatInt(usage.totalTokens)}, unvollständig`;
  return formatInt(usage.totalTokens);
}

/** Tokens je gelöstem Ticket: null → „–“; ganzzahlig, bei unvollständiger Usage als Untergrenze. */
export function formatTokensPerResolved(value: number | null | undefined, usage?: UsageTotals | null): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '–';
  if (usage && !usage.complete) return `mindestens ${formatInt(value)}, unvollständig`;
  return formatInt(value);
}

export function usageHint(usage: UsageTotals | null | undefined): string | null {
  if (!usage || usage.complete) return null;
  const n = usage.unknownCalls;
  return `${n} ${n === 1 ? 'Modellaufruf hat' : 'Modellaufrufe haben'} keinen Verbrauch gemeldet.`;
}
